import { TextField } from "@mui/material"
import { Nullable } from "../../../common-types"
import { InputStyle } from "./style"

export const FloatInput = ({
    label,
    value,
    required,
    error,
    onChange,
    onBlur
}:{
    label:string
    value: Nullable<Number>
    required?: boolean
    error?: boolean
    onChange: (val: Nullable<number>) => void 
    onBlur?: () => void
}) => {

    const toNumber = (val: string | null | undefined): number | null => {
        if(val) {
            return parseFloat(val)
        }
        return null
    }

    return (
        <TextField
            label={label}
            type="number"
            {...InputStyle}
            required={required}
            inputProps={{ step: "any" }} 
            error={error}
            fullWidth
            value={value}
            onChange={(e) => onChange(toNumber(e.target.value))}
            onBlur={onBlur}
            />
    )
}